import * as React from 'react';
import S from 's-js';
import * as $ from 'jquery';
import SuperCritical, { SuperCriticalComponent } from 'lib/supercritical';

import TZDate from 'lib/TZDate';
import { tzmoment } from 'lib/tzmoment';
import { EN_DURATIONS_ABBR_LOCALE } from 'lib/moment-custom-locales';

import 'lib/twitter-bootstrap-loader';

interface MaxLengthTooltipProps {
    maxLength : number;
    text : () => string;
    className? : string;
}

export const MaxLengthTooltip = SuperCritical(({ maxLength, text, className } : MaxLengthTooltipProps) =>
    <PCTooltip className={className} title={text} shown={() => text().length > maxLength}>
        {text()}
    </PCTooltip>
);

const TOOLTIP_DATE_FORMAT = 'MM/DD/YY [at] HH:mm';

interface TimeAgoTooltipProps {
    date : () => TZDate;
    now : () => TZDate;
    className? : string;
    useAbbreviatedTimeAgo? : boolean;
}

export const TimeAgoTooltip = SuperCritical(({ className, date, now, useAbbreviatedTimeAgo } : TimeAgoTooltipProps) =>
    <PCTooltip className={className} title={() => tzmoment(date()).format(TOOLTIP_DATE_FORMAT)}>
        {setLocale(date(), useAbbreviatedTimeAgo).from(now())}
    </PCTooltip>
);

function setLocale(date : TZDate, useAbbreviatedTimeAgo : boolean | undefined) {
    const m = tzmoment(date);
    if (useAbbreviatedTimeAgo) m.locale(EN_DURATIONS_ABBR_LOCALE);
    return m;
}

interface PCTooltipProps {
    title : () => string;
    shown? : () => boolean;
    className? : string;
    children? : any;
}

export class PCTooltip extends SuperCriticalComponent<PCTooltipProps> {
    tooltipRef : (e : HTMLDivElement | null) => void;

    constructor(props : PCTooltipProps) {
        super(props);

        let el : HTMLDivElement | null = null;
        const event = S.data(null);

        // TH 1/3/2017 -- BUGFIX. Previously, we used a SuperCriticalReference here.
        // That had the side effect that changing props would cause the tooltip to be
        // destroyed and reconstructed. That had the undesirable effect that time ago
        // tooltips would get destroyed whenever their clock ticked.
        // So manually construct a ref that doesn't subscribe to this.state.props.
        S.root(() => S(() => {
            event();
            if (el) {
                let $el = $(el);
                $el.tooltip({
                    // TH 1/3/2017 -- NOTE: Bootstrap only calls this title function when hovering into a tooltip.
                    // That means the tooltip text won't update if the title or shown props change during a hover.
                    // The update will only become visible on the next hover.
                    title: () => S.sample(() => this.sprops().shown && !this.sprops().shown!() ? '' : this.sprops().title())
                });
                S.cleanup(() => $el.tooltip('destroy'));
            }
        }));

        this.tooltipRef = (_el : HTMLDivElement | null) => { el = _el; event(null); };
    }

    srender(props : PCTooltipProps) : React.ReactElement<any> {
        return (
            <div className={props.className} ref={this.tooltipRef}>
                {props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/pctooltip/view.tsx